import React, { useState } from "react";
import { Panel } from "cprime-foundational-components";
import { Stack } from "@mui/material";
import { createFeatureGroup } from "../../services/RequestAccess/RequestAccess";
import { triggerToast } from "../../utils/toast";
import * as style from "./FeatureGroup.module.scss";
import FeatureGroupSidebarContent from "./FeatureGroupSidebarContent";

import Button from "../../Components/Common/CprimeButton";
interface ValueStreamSidePanelProps {
  open: boolean;
  onClose: () => void;
  setTriggerEffect: any;
  triggerEffect: any;
}

const FeatureGroupSidebar: React.FC<ValueStreamSidePanelProps> = ({
  open,
  onClose,
  setTriggerEffect,
  triggerEffect,
}) => {
  const scssClass = style as any;
  const [loading, setLoading] = useState(false);
  const [formValue, setFormValue] = useState({
    name: "",
    description: "",
    isVisible: true,
  });

  const handleSave = async () => {
    const payload = {
      group_name: formValue?.name,
      group_description: formValue?.description,
      is_visible: formValue?.isVisible,
    };
    try {
      setLoading(true);
      const response = await createFeatureGroup(payload);

      if (response?.error) {
        triggerToast(`${response?.error}`, "error");
      } else if (response?.status === "SUCCESS") {
        triggerToast(`${response?.message}`, "success");
        onClose();
        setTriggerEffect(!triggerEffect);
      }
      // triggerToast(`${response?.message}`, response?.status?.toLowerCase());
    } catch (err) {
      // console.error("Group save failed:", err);
    } finally {
      setLoading(false);
    }
    // setNameValueStream("");
    // setDes("");
  };

  return (
    <>
      <Panel
        id="valueStreamSidePanel"
        className={scssClass.userGroupMainPanel}
        sx={{
          "& .MuiDrawer-root": { padding: "0" },
          "& .MuiPaper-root": {
            width: "fit-content",
            minWidth: "800px",
            top: "104px",
            height: "calc(100vh - 104px)",
            gap: "24px",
          },
        }}
        open={open}
        title={"Create Feature Group"}
        side="right"
        onClose={onClose}
        body={
          <>
            <FeatureGroupSidebarContent
              setFormValue={(key: any, value: any) => {
                setFormValue({ ...formValue, [key]: value });
              }}
              formValue={formValue}
            />
            <Stack
              direction="row"
              justifyContent="flex-end"
              textAlign="right"
              p="1rem 0rem 0rem 0rem"
              className={scssClass.footerButtons}
            >
              <Stack direction="row" gap={1}>
                <Button variant="tertiary" onClick={() => onClose()}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  disabled={
                    !formValue?.name?.trim() || !formValue?.description?.trim()
                  }
                  onClick={handleSave}
                  loading={loading}
                >
                  Create
                </Button>
              </Stack>
            </Stack>
          </>
        }
      />
      <span
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          position: "fixed",
          width: "100vw",
          height: "calc(100vh - 104px)",
          zIndex: 1100,
          top: "104px",
          left: 0,
        }}
      ></span>
    </>
  );
};

export default FeatureGroupSidebar;
